<template>
  <div class="content">
    <commonHeader isWhite titleText="Repayment" diyHeaderColor="#fff" :pageTitle="title"></commonHeader>

    <div class="content-box">
      <div class="limitInfo">
        <div class="productInfo">
          <div class="infoLeft">
            <img :src="img" alt="">
            <span>{{ productName }}</span>
          </div>
          <div class="infoRight" @click="showBox">
            <img v-if="showingImage" src="@/assets/common/toTop.png" alt="">
            <img v-else src="@/assets/common/toBottom.png" alt="">
          </div>
        </div>

        <div class="repayInfo">
          <div class="repayItem">
            <div class="itemLeft">Extension fee:</div>
            <div class="itemRight">₹{{amount?dataMoney(amount):'0' }}</div>
          </div>
          <div class="repayItem">
            <div class="itemLeft">New due date:</div>
            <div class="itemRight">{{delayExpiryTime?Time(delayExpiryTime):'0' }}</div>
          </div>
        </div>

        <div class="box-btn" @click="pay">Pay</div>

        <div class="repaymentDetails" v-if="showingImage">
          <div class="detailsTitle">Repayment details:</div>
          <div class="detailsInfo" v-for="(item,index) in list" :key="index">
            <div class="infoLeft">{{ item.resume }}</div>
            <div class="infoRight" v-html="item.survival"></div>
          </div>
        </div>
      </div>

      <div class="tipContent">
        <div class="tipItem">
          1. Once your UPI has expired, please return to the repayment page to acquire a new UPI for repayment.
        </div>
        <div class="tipItem">
          2. If the status of your paid order has not been updated, submit proof of payment, and we will handle the payment processing for you.
        </div>
        <div class="tipItem">
          3.You need to obtain upi for each repayment. Please do not repay multiple times with the same upi.
        </div>
        <div class="tipItem">
          Please repay according to the order amount.
        </div>
      </div>

      <div class="uploadUTR">
        <div class="utrTitle">Upload proof of payment</div>
        <van-field
          v-model="userfrom.utr"
          type="digit"
          placeholder="Enter UTR"
          autocomplete="off"
        />
        <van-field
            v-model="userfrom.amount"
            autocomplete="off"
            left-icon=""
            type="digit"
            placeholder="Enter the exact amount of payment"
            @click="addCurrencySymbol"
            @input="inputCurrencySymbol"
            @blur="blurCurrencySymbol"
          >
        </van-field>
      </div>

      <div class="uploadImage">
        <div class="imageTitle">Screenshot proof (optional)</div>
        <div class="bottomImg">
          <div class="Img" v-for="(item,index) in listImg" :key="index">
            <img class="imgItem" :src="item" alt="">
            <img src="@/assets/repayment/off.png" alt="" class="offImg" @click="delImg(index)">
          </div>
          <div class="addImg" @click="addImg" v-if="listImg.length < 3">
            <img src="@/assets/repayment/addImg.png" alt="">
            <p>Add pictures </p>
          </div>
        </div>
        <van-button
          type="primary"
          class="bottom-btn" 
          :disabled="!userfrom.utr||!userfrom.amount"
          :color="!userfrom.utr||!userfrom.amount ? '#DCDCDC' : '#4A44C6'"
          @click="Submit">
          Submit
        </van-button>
      </div>
    </div>
  
    <loanDlog ref="loanDlog"></loanDlog>
    
  </div>
</template>

<script>
import { Toast } from 'vant';
import { dataMoney } from '@/utils/money'
import { Time } from '@/utils/time'
import loanDlog from '@/components/loanDlog.vue'
import { base64ToImage } from '@/utils/baseImg'
import {getOrderDetails,getDelayFlexble,getRepaymentDetail} from '@/views/repaymentExtension/lib.js'
import {getUpOrderUtr} from '@/http/repayment'
import commonHeader from '@/components/commonHeader.vue'
export default {
name:'orDer',
components:{loanDlog, commonHeader},
data(){
 return{
  isListVisible:false,
  showingImage:false,
  title:'DelayRepayment',
  productName:null,
  delayExpiryTime:null,
  loadingBtn:false,
  loading:true,
  amount:null,
  orderNo:localStorage.getItem('orderNo')||'',
  img:null,
  userfrom: {
        utr: '',
        amount: '',
      },
  listImg:[],
  list:[]
 }
},
watch:{
  'userfrom.utr': {
    handler (ne, old) {
      console.log(ne,'ne----------');
      if (ne.length >= old.length) {
        this.$managementEvents({ pageName: 'extensive', action: 'not', extInfo: {  utr: this.userfrom.utr} })
      }
    }
  },
  'userfrom.amount': {
    handler (ne, old) {
      console.log(ne,'ne----------');
      if (ne.length >= old.length&&ne!=='₹') {
        const amount = this.userfrom.amount.replace(/₹/g, '');
    this.$managementEvents({ pageName: 'extensive', action: 'household', extInfo: {  amount: amount} })
      }
    }
  }
},
methods: {
  dataMoney,
  Time,
  showBox(){
    this.isListVisible = !this.isListVisible
      this.showingImage = !this.showingImage
  },
  //订单详情
 async getOrderDetails(){
  const loadingInstance = Toast.loading(
        {
          message: 'Loading...', 
          duration: 0, // 设置为 0 表示持续加载直到手动关闭
          forbidClick: true, // 防止用户点击
          closeOnClick: false // 设置为 true 可以点击关闭 loading
        }
      )
   const res=await getOrderDetails({
      pageType:2,
      orderNo:this.orderNo 
   })
   console.log(res,'逾期订单详情');
 if(res.authority==='200'){
  loadingInstance.clear()
  this.loading=false
   this.productName=res.same.glad
  this.img = res.same.dish
   ? base64ToImage(`${'data:image/png;base64,' + res.same.dish}`)
   : require('@/assets/common/defaultOrderImg.png')

 }
  },
   //展期订单
 async getDelayFlexble(){
   const res=await getDelayFlexble({
    delayTerm: '',
    orderNo:this.orderNo, 
    termUnit: ''
   })
   console.log(res);
   this.amount=res.same.extraordinary
   this.delayExpiryTime=res.same.hormone
   this.list=res.same.pork
  },
 async pay(){
  const loadingInstance = Toast.loading(
        {
          message: 'Loading...',
          duration: 0, // 设置为 0 表示持续加载直到手动关闭
          forbidClick: true, // 防止用户点击
          closeOnClick: false // 设置为 true 可以点击关闭 loading
        }
      )
  this.$managementEvents({ pageName: 'extensive', action: 'gift', extInfo: '' })
  if (this.loadingBtn) return
      this.loadingBtn = true
    const res=await getRepaymentDetail({
      delayTerm: 2,
      orderNo:this.orderNo,
      requestType: 2
     })
     console.log(res);
     loadingInstance.clear()
     this.$router.push({ name: 'easyPay', params: { url:res.same.deserve[0].character,name:'repaymentExtension' } })
     setTimeout(() => {
        // 模拟操作完成后的处理

        this.loadingBtn = false // 操作完成后将加载状态设置为false，允许下次点击
      }, 1000) // 这里的1000表示操作的耗时，实际情况根据具体操作来确定
  },

    
    addCurrencySymbol() {
      // 当输入框被点击时，如果当前值为空，则添加金额符号
      if (this.userfrom.amount === '') {
        this.userfrom.amount = '₹';
      }
    },
    inputCurrencySymbol(value) {
    
      // 当输入框被点击时，如果当前值为空，则添加金额符号
      if (value === '') {
        this.userfrom.amount = '₹';
      }
      if (value && value.charAt(0) !== '₹') {
        this.userfrom.amount = '₹' + value;
        //
      }
    },
    blurCurrencySymbol() {
      // 当输入框被点击时，如果当前值为空，则添加金额符号
        if( this.userfrom.amount ==='₹'){
          this.userfrom.amount = '';
      
        }
       
    },
    delImg(index){
      console.log(index);
      this.listImg.splice(index, 1);
    },
    addImg(){
      // 调取ios方法获取图片
      this.$managementEvents({ pageName: 'extensive', action: 'ill', extInfo: '' })
      this.$javaGet('backImg',(res)=>{
        if(this.listImg.length===2 && res[0].length>1){
          Toast('Only select up to 3 images')
        }else if(this.listImg.length===1 && res[0].length>2){
          Toast('Only select up to 3 images')
        }else if(this.listImg.length===0 && res[0].length>3){
          Toast('Only select up to 3 images')
        }else{
          res[0].forEach(item => {
      this.listImg.push(`data:image/png;base64,${item}`);
    });
        }
        this.$managementEvents({ pageName: 'extensive', action: 'green', extInfo: {img:  this.listImg} })
      })
    },
    dataURLtoFile(dataurl, filename) { 
        var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    },
    async Submit(){
      this.$managementEvents({ pageName: 'extensive', action: 'wash', extInfo: '' })
      const amount = this.userfrom.amount.replace(/₹/g, '');
      const res=await getUpOrderUtr({
       orderNo:this.orderNo,
        utr:this.userfrom.utr,
        img:this.listImg.map(item => this.dataURLtoFile(item)),
        amount:amount
      })
      if(res.authority==='200'){
        Toast('Submit Success')
        this.$managementEvents({ pageName: 'extensive', action: 'intimate', extInfo:  {  utr: this.userfrom.utr} })
        setTimeout(()=>{
          this.$javaGet('backHome')
        },500)
      }
    },
    showLoan(){
      this.$refs.loanDlog.show=true
    }
  

  },
  mounted(){
    this.getOrderDetails()
    this.getDelayFlexble()
    this.$managementEvents({ pageName: 'extensive', action: 'everything', extInfo: { loanOrderId: this.orderNo } })
  }
}
</script>

<style lang="less" scoped>
.content{
  background: #fff;
  padding-top: 55px;
  position:relative;
  min-height: 100vh;
  .content-box{
    width: 100%;
    padding: 16px;
    padding-bottom: 20px;
    .limitInfo {
      background-color: #EBEBFE;
      border-radius: 10px;
      padding: 16px;
      margin-bottom: 16px;
      .productInfo {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .infoLeft {
          display: flex;
          align-items: center;     
          img {
            width: 32px;
            height: 32px;
            margin-right: 10px;
          }
          span {
            color: #000004;
            font-size: 14px;
          }
        }
        .infoRight {
          display: flex;
          align-items: center;
          margin-left: 12px;
          img {
            width: 22px;
            height: 22px;
          }
        }
      }
      .repayInfo {
        .repayItem {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 16px;
          .itemLeft {
            color: #999999;
            font-size: 14px;
          }
          .itemRight {
            color: #000000;
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
      .box-btn {
        height: 50px;
        background-color: #4A44C6;
        border-radius: 26px;
        color: #FFFFFF;
        font-size: 16px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0 16px 0;
      }
      .repaymentDetails {
        .detailsTitle {
          text-align: left;
          color: #000004;
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 10px;
        }
        .detailsInfo {
          margin-bottom: 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .infoLeft {
            color: #999999;
            font-size: 14px;
          }
          .infoRight {
            color: #000000;
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }
    .tipContent {
      background-color: #FFECEC;
      border-radius: 10px;
      padding: 12px;
      margin-bottom: 16px;
      .tipItem {
        color: #FE5050;
        font-size: 12px;
        text-align: left;
        margin-bottom: 2px;
      }
    }
    .uploadUTR {
      text-align: left;
      margin-bottom: 18px;
      .utrTitle {
        color: #0C0B10;
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 12px;
      }
    }
    .uploadImage {
      text-align: left;
      .imageTitle {
        color: #0C0B10;
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 12px;
      }
      .bottomImg {
        display: flex;
        .Img {
          width: 88px;
          height: 88px;
          margin-right: 10px;
          position: relative;
          .imgItem {
            width: 100%;
            height: 100%;
            border-radius: 10px;
          }
          .offImg {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 30px;
            height: 30px;
          }
        }
        .addImg {
          width: 88px;
          height: 88px;
          border-radius: 10px;
          background-color: #F7F7F7;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img {
            width: 26px;
            height: 26px;
            margin-bottom: 12px;
          }
          p {
            color: #A1A1A1;
            font-size: 12px;
          }
        }
      }
      .bottom-btn {
        width: 100%;
        margin-top: 20px;
        height: 50px;
        border-radius: 26px;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
      }
    } 
  }
}
/deep/ .van-field {
  border: 1px solid #DCDCDC;
  border-radius: 10px;
  margin-bottom: 10px;
  .van-field__control {
    &::placeholder {
      color: #C3C3C3;
    }
  }
}
</style>